import {
  DashboardOpcSetting,
  DashboardOpcSettingInputs,
} from '../../types/app/dashboardOpcSetting';

import {
  Dashboard,
  DashboardCreateRequest,
  DashboardUpdateRequest,
} from '../../types/app/dashboards.types';

import { api } from '../core/api';

export const getDashboardList = (id: number) =>
  api.get<Dashboard[]>(`Dashboard/GetList?parentId=${id}`).then((res) => res.data);

export const getDashboard = (id: number) =>
  api.get<Dashboard>(`Dashboard/GetItem/?id=${id}`).then((res) => res.data);

export const updateDashboard = (data: DashboardUpdateRequest) =>
  api.put(`Dashboard/UpdateItem`, data).then((res) => res.data);

export const createDashboard = (data: DashboardCreateRequest) =>
  api.post(`Dashboard/CreateItem`, data).then((res) => res.data);

export const deleteDashboard = (id: number) =>
  api.delete<Dashboard>(`Dashboard/DeleteItem/?id=${id}`).then();

export const grafanaCreateDashboardForAsset = (data: DashboardCreateRequest) =>
  api
    .post(
      `Dashboard/GrafanaCreateDashboardForAsset?type=${data.type}&assetId=${data.assetId}&name=${data.name}`,
      data,
    )
    .then((res) => res.data);

// Opc
export const getDashboardOpcSetting = (dashboardId: number) =>
  api
    .get<DashboardOpcSetting>(`Dashboard/GetDashboardOpcSetting/?dashboardId=${dashboardId}`)
    .then((res) => res.data);

export const updateDashboardOpcSetting = (data: DashboardOpcSettingInputs) =>
  api.put(`Dashboard/UpdateDashboardOpcSetting`, data).then((res) => res.data);
